import React from "react";
import "./OrangeFilledRoundBtn.css";
import { Button } from "react-bootstrap";

function OrangeFilledRoundBtn({type, btnText, onClick }) {
  return (
    <section className="OrangeFilledRoundBtn">
      <Button className="Orange_Btn" onClick={onClick} type={type}>{btnText}</Button>
    </section>
  );
}

export default OrangeFilledRoundBtn;
